const dateRangeSearchParamKeys = ["dateStart", "dateEnd"] as const

export const appendDateRangeSearchParams = (target: URLSearchParams, sourceSearch: string) => {
  const source = new URLSearchParams(sourceSearch)

  dateRangeSearchParamKeys.forEach((key) => {
    const value = source.get(key)?.trim()

    if (value) {
      target.set(key, value)
    }
  })

  return target
}

export const getDateRangeSearch = (sourceSearch: string) => {
  const searchParams = appendDateRangeSearchParams(new URLSearchParams(), sourceSearch)

  const query = searchParams.toString()

  return query.length > 0 ? `?${query}` : ""
}
